import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useLoader } from "../../utils/LoaderUtils";
import RowsPerPage from "../../components/partials/RowsPerPage";
import Pagination from "../../components/partials/Pagination";
import { formatDate } from "../../helper/Helper";
import customerAPI from "../../api/customerApi";

function Queries() {
  const [items, setItems] = useState([]);
  const [pagination, setPagination] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const { showLoader, hideLoader } = useLoader();

  const query = useMemo(
    () => ({
      page: Number(searchParams.get("page")) || 1,
      limit: Number(searchParams.get("limit")) || 10,
      search: searchParams.get("search") || "",
    }),
    [searchParams],
  );

  const fetchQueries = useCallback(async () => {
    showLoader();

    try {
      const res = await customerAPI.getQueriesList(query);

      if (res.code === 200) {
        setItems(res.data.queries);
        setPagination(res.data.pagination);
      }
    } catch (err) {
    } finally {
      hideLoader();
    }
  }, [query]);

  useEffect(() => {
    fetchQueries();
  }, [fetchQueries]);

  const updateFilter = useCallback((key, value) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (value) params.set(key, value);
      else params.delete(key);
      return params;
    });
  }, []);

  const startIndex = useMemo(() => {
    return (query.page - 1) * query.limit;
  }, [query]);

  return (
    <div className="content">
      <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>All Queries</h4>
            <h6>List of queries submitted by customers using contact form</h6>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="row">
            <div className="col-md-6">
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  <i className="ti ti-search" />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search By Email Address/Phone Number"
                  value={searchParams.get("search") || ""}
                  onChange={(e) => updateFilter("search", e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          <div className="row">
            <div className="col-md-12">
              <div className="countablepagination p-2">
                <p>
                  Showing {(pagination.page - 1) * pagination.limit + 1} to{" "}
                  {Math.min(
                    pagination.page * pagination.limit,
                    pagination.total,
                  )}{" "}
                  of {pagination.total} results
                </p>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table">
              <thead className="thead-light">
                <tr>
                  <th>S. No. </th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Message</th>
                  <th>Created At</th>
                </tr>
              </thead>
              <tbody>
                {items.length > 0 ? (
                  items.map((item, index) => (
                    <tr key={item._id}>
                      <td>{startIndex + index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.email}</td>
                      <td>{item.phone}</td>
                      <td>{item.message}</td>
                      <td>{formatDate(item.createdAt)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center p-4 text-muted">
                      No query found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="row">
            <RowsPerPage
              value={searchParams.get("limit") || "10"}
              onChange={(val) => updateFilter("limit", val)}
            />

            <Pagination pagination={pagination} updateFilter={updateFilter} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Queries;
